module.exports = __webpack_public_path__ + "img/15.3bff21c4.jpg";